import {AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Item} from '../../../data/item';
import {AdminPanelService} from '../../../data/admin-panel.service';
import {HttpEventType, HttpProgressEvent, HttpResponse} from '@angular/common/http';
import {ProjectFile} from '../../../../project-misc/data/project/project-file';
import {
  ImageGalleryCarouselComponent
} from '../../../../project-misc/view/image-gallery-carousel/image-gallery-carousel.component';
import {API_URL} from '../../../../../../../../core/src/lib/core/utils/tokens';
import {PdfPreviewDialogComponent} from '../../../../project-misc/view/pdf-preview-dialog/pdf-preview-dialog.component';
import {DeviceDetectorService} from 'ngx-device-detector';
import {ShortObject} from '../../../../project-misc/data/project/short-json-object';
import {timer} from 'rxjs';
import {ProjectCalcService} from '../../../../project-calc/data/project-calc.service';
import {FileService} from '../../../../../../../../core/src/lib/misc/data/file/file.service';
import {FileOpenerService} from '../../../../project-misc/utils/fileOpener.service';

@Component({
  selector: 'app-misc-item-files-dialog',
  templateUrl: './misc-item-files-dialog.component.html',
  styleUrls: ['./misc-item-files-dialog.component.scss'],
  providers: [DeviceDetectorService]
})
export class MiscItemFilesDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  misc: Item;

  filesToUpload: File[] = [];

  miscFiles: ProjectFile[] = []

  progressBar: number;

  isDesktop: boolean;
  isMobile: boolean;

  filesLoading: boolean;

  newMisc = false;

  saveLoading: boolean;

  @ViewChild('miscName', {static: true})
  miscInput: ElementRef;

  miscGroups: ShortObject[]
  miscGroup: ShortObject;

  constructor(
    @Inject(API_URL) protected apiUrl: string,
    private matDialog: MatDialog,
    protected fileService: FileService,
    protected fileOpenerService: FileOpenerService,
    protected adminPanelService: AdminPanelService,
    protected projectCalcService: ProjectCalcService,
    private deviceService: DeviceDetectorService,
    protected dialogRef: MatDialogRef<MiscItemFilesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {
      misc: Item,
      newItemName: string
    }) {
    if (this.data.misc) {
      this.misc = this.data.misc
    } else {
      this.misc = new Item()
      this.misc.name = this.data.newItemName
      this.newMisc = true;
    }
  }

  ngOnInit(): void {
    this.listenForPaste();

    this.isDesktop = this.deviceService.isDesktop();
    this.isMobile = this.deviceService.isMobile();

    if (!this.newMisc) {
      this.filesLoading = true;
      this.adminPanelService.getMiscFiles(this.misc.id).subscribe(files => {
        this.miscFiles = files

        this.filesLoading = false;
      }, error => {
        this.filesLoading = false;
      })
    } else {
      this.adminPanelService.getMiscGroupNames().subscribe(groupItems => {
        this.miscGroups = groupItems

        // CUSTOM ITEM GROUP
        this.miscGroup = this.miscGroups.find(group => group.id === 7)
      })
    }
  }

  listenForPaste() {
    document.onpaste = event => {
      const items = event.clipboardData.items;
      // tslint:disable-next-line:forin
      for (const index in items) {
        const item = items[index];
        if (item.kind === 'file') {
          const file = item.getAsFile();
          this.uploadFile([file])
        }
      }
    };
  }

  ngOnDestroy() {
    document.onpaste = event => {
    }
  }

  ngAfterViewInit() {
    timer(100).subscribe(emit => {
      const fileupload = document.getElementsByClassName('p-fileupload-choose')[0] as HTMLSpanElement
      if (fileupload) {
        fileupload.removeAttribute('tabindex')
      }
    })
  }

  closeDialog() {
    this.dialogRef.close()
  }

  uploadFile(files, filesForm?) {
    if (this.newMisc) {
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < files.length; i++) {
        this.filesToUpload.push(files[i])

        this.miscFiles.push({
          id: null,
          name: files[i].name
        })
      }

      if (filesForm) {
        filesForm.clear();
      }
    } else {
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < files.length; i++) {
        this.filesToUpload.push(files[i])
      }

      this.uploadFiles(filesForm)
    }

  }

  uploadFiles(filesForm?) {
    const fileArray = [];
    this.progressBar = 1

    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < this.filesToUpload.length; i++) {
      fileArray.push(this.filesToUpload[i])
    }

    this.adminPanelService.uploadMiscFiles(fileArray, this.misc.id).subscribe(httpEvent => {
      if (httpEvent.type === HttpEventType.UploadProgress) {
        const progressEvent = httpEvent as HttpProgressEvent
        this.progressBar = Math.ceil(progressEvent.loaded / progressEvent.total * 100 / 3) * 3


      } else if (httpEvent.type === HttpEventType.Response) {
        const newFiles = (httpEvent as HttpResponse<ProjectFile[]>).body;
        this.miscFiles = this.miscFiles.concat(newFiles)
        this.progressBar = 0;

        this.misc.hasFiles = true;

        this.filesToUpload = []

        if (this.newMisc) {
          this.dialogRef.close(this.misc)
        }
      }
      if (filesForm) {
        filesForm.clear();
      }
    }, error => {
      this.progressBar = 0
      this.filesToUpload = []
    })
  }

  onProgress(event) {
    this.progressBar = event.progress;

    if (this.progressBar === 100) {
    }
  }

  deleteFile(file: ProjectFile, index: number) {
    if (this.newMisc) {
      this.miscFiles.splice(index, 1);
      return;
    }
    this.adminPanelService.deleteMiscFile(file.id).subscribe(deleted => {
      this.miscFiles.splice(index, 1);

      if (this.miscFiles.length === 0) {
        this.misc.hasFiles = false;
      }
    })

  }

  openFile(miscFile: ProjectFile) {
    if (this.newMisc) {
      return;
    }

    this.fileOpenerService.openFile(miscFile, this.miscFiles, true)
  }


  saveMiscItem() {
    this.saveLoading = true;
    this.misc.groupId = this.miscGroup.id;

    let tempMisc = Object.assign({}, this.misc)

    if (this.misc.forThisProjectOnly) {
      tempMisc.projectId = this.projectCalcService.lastChosenPricingProjectId
      delete tempMisc.forThisProjectOnly
      delete tempMisc.groupId
    }


    this.adminPanelService.createNewMisc(tempMisc).subscribe(newMisc => {
      this.misc = newMisc
      if (this.miscFiles && this.miscFiles.length > 0) {
        this.uploadFiles()
      } else {
        this.dialogRef.close(newMisc)
      }
    }, error => {
      this.saveLoading = false;
    })
  }

  getIcon(ext: string) {
    return this.fileService.getIcon(ext);
  }

  getTinyIcon(fileId: number) {
    return this.fileService.getImageThumbNail(fileId)
  }
}
